import React from "react";
import { Link } from "react-router-dom";
import { Col, Row, Card, Spinner } from "reactstrap";

// import images
import bg from "../../assets/images/bg.jpg";
import logoDark from "../../assets/images/logo-dark.png";
import bgImage from "../../assets/images/bgImage1.jpg";

import TrueFocus from "pages/Ui/React-blits/TrueFocus";
import { useForm } from "react-hook-form";
import useIniDataFromDb from "./useIniDataFromDb";
import useLoginTA from "./useLoginTA";
// import secLogo from "../../assets/images/TF Logo small.jpg";
// import secLogo from "../../assets/images/TrueFocus_updated2025_weblogo.png";
import secLogo from "../../assets/images/Appraisal_Hunter_print_tm.jpg";

const Login2 = () => {

  const{register,handleSubmit,formState:{errors}}=useForm({
    defaultValues:{
      email:"",
      password:""
    },
    criteriaMode:"all",
    mode:"onChange"
  })
  
  // initial data hook
  const{isPending,isSuccess,isError,error,data}=useIniDataFromDb();
  // logiin custom hook
  const{isSigningIn,login}=useLoginTA();

  const onSubmit = (data)=>{
    console.log("login suceeded",data)
    login(data)
  }

  document.title = "Title Appraiser | Login";
  return (
    <React.Fragment>
      <div className="account-pages">
        <div
          className="accountbg"
          style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Card style={{ height: "90vh", display: "flex", borderRadius:"15px", margin:"40px", borderColor:"transparent", borderWidth:"1.5px",background:"transparent"}}>
            <Row style={{height:"100%"}}>
              <Col md={6} style={{ display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center",borderWidth:"10px", borderColor:"black"}}>
                <TrueFocus borderColor="#00ADF0"/>
              </Col>

              <Col md={6}  className="d-flex flex-column justify-content-center align-items-center">
                <div style={{borderRadius:"10px", width:"90%", height:"90%",backgroundColor:"white",backdropFilter:"blur(10px)",opacity:"0.9"}}>
                  <div className="text-center mt-5 pt-4">
                    <img className="img-fluid" src={secLogo} alt="TrueFocus Automation" style={{width:"400px"}}/>
                  </div>
                  {/* <p className="text-muted text-center fs-6 pt-3">
                    Desktop Appraisal
                  </p> */}

                  {/* form */}
                  <Row className="justify-content-center">
                    <Col xs="12" sm="12" md="9" lg="8">
                        <form className="mt-1 p-1 m-4" onSubmit={handleSubmit(onSubmit)}>
                    <Card className="p-4">
                      <div className="mb-2">
                      <label htmlFor="email" className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control border-primary-subtle"
                        id="email"
                        name="email"
                        placeholder="Email here...."
                        {...register("email",{required:"Email is required",
                          setValueAs:(value)=>value?.trim().toLowerCase(),
                          minLength:{value:6,message:"Email must have atleast 6 characters"},
                          pattern:{value:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message:"Invalid email format"}
                        })}
                      />
                      {errors.email && <span className="text-danger">{errors.email.message}</span>}
                    </div>

                    <div className="mb-2">
                      <label htmlFor="password" className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control border-primary-subtle"
                        id="password"
                        name="password"
                        // value='True@001'
                        placeholder="Password here...."
                        {...register("password",{required:"Password required",
                          minLength:{value:6,message:"Password must be at least 6 characters long"},
                          maxLength:{value:15, message:"Password must not exceed 12 characters"},
                          pattern:{value:/^(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{6,15}$/,
                          message:"Password must be 6–12 characters long, include at least one uppercase letter, one lowercase letter, one number, one special character, and contain no spaces."}
                        })}
                      />
                      {errors.password && <span className="text-danger">{errors.password.message}</span>}
                    </div>

                      <div className="mt-3" style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                        <button disabled={isSigningIn} type="submit" className="btn py-2" style={{backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder"}}>
                          {isSigningIn ? <Spinner size="sm" /> : 'Submit'}
                        </button>
                      </div>

                      <div className="mt-3 text-center"> 
                        <p>
                          <Link
                            to="/register"
                            className="fw-medium"
                            style={{color:"#00ADF0"}}
                            >
                            {" "}
                            Don’t have an account? Sign up{" "}
                            </Link>{" "}
                        </p>
                        <p>
                          <Link
                            to="/reset-password"
                            className="fw-medium"
                            style={{color:"#00ADF0"}}
                            >
                            {" "}
                            Forgot Your Password?{" "}
                            </Link>{" "}
                        </p>
                      </div>
                      <div className="text-center mt-1 pt-2 ">
                        © {new Date().getFullYear()} TrueFocus Automation.All rights reserved.
                      </div>
                    </Card>
                  </form>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>
        </div>

        
        {/* <div className="account-page-full" >
          <Card className="shadow-none">
            <div className="card-block">
              <div className="account-box">
                <div className="card-box shadow-none p-4">
                  <div className="p-2">
                    <div className="text-center mt-4">
                      <Link to="/">
                        <img src={logoDark} height="22" alt="logo" />
                      </Link>
                    </div>

                    <h4 className="font-size-18 mt-5 text-center">
                      Welcome Back !
                    </h4>
                    <p className="text-muted text-center">
                      Sign in to continue to Veltrix.
                    </p>

                    <form className="mt-4" action="#">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="username">Username</label>
                        <input
                          type="text"
                          className="form-control"
                          id="username"
                          placeholder="Enter username"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label" htmlFor="userpassword">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="userpassword"
                          placeholder="Enter password"
                        />
                      </div>

                      <Row className="mb-3">
                        <Col sm={6}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customControlInline"
                            >
                              Remember me
                            </label>
                          </div>
                        </Col>

                        <Col sm="6" className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Log In
                          </button>
                        </Col>
                      </Row>

                      <Row className="mb-3 mt-2 mb-0">
                        <div className="col-12 mt-3">
                          <Link to="/pages-recoverpw-2">
                            <i className="mdi mdi-lock"></i> Forgot your
                            password?
                          </Link>
                        </div>
                      </Row>
                    </form>

                    <div className="mt-5 pt-4 text-center">
                      <p>
                        Don't have an account ?{" "}
                        <Link
                          to="/pages-register-2"
                          className="fw-medium-medium text-primary"
                        >
                          {" "}
                          Signup now{" "}
                        </Link>{" "}
                      </p>
                      <p>
                        © {new Date().getFullYear()} Veltrix. Crafted with{" "}
                        <i className="mdi mdi-heart text-danger"></i> by
                        Themesbrand
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div> */}


      </div>
    </React.Fragment>
  );
};

export default Login2;
